<template>
  <div class="page" v-wechat-title="$route.meta.title">
    <div class="guidedetail-top border-box">
      <img class="guidedetail-bg" src="../../assets/guidedetail-bg.jpg">
      <span class="focus-btn none">关注</span>
      <p class="listen-btn-top" @click="playGuideVoice()">
        <audio src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3" id="audioGuide"></audio>
        <img :src="audioPlay==1?require('../../assets/guidedetail-video.gif'):require('../../assets/guidedetail-video-play.png')" alt="">
      </p>
      <img class="guidedetail-share none" src="../../assets/guidedetail-share.png" />

      <p class="guidedetail-img-box">
        <img class="img guidedetail-img" v-lazy="bagInfo.img" @click="seeImg(0,bagInfo.img)" />
        <img v-on:click="btnVideo()" v-if="hasVideo==1" class="guidedetail-video" src="../../assets/icon_play_btn10.png"/>
      </p>
      <p class="guidedetail-name">
        <span class="fl" style='font-weight:bold;'>{{bagInfo.name}}</span>
        <span class="guidedetail-des fl" v-if="bagInfo.guidetag != null && bagInfo.guidetag != ''">{{bagInfo.guidetag}}</span>
      </p>
      <p class="guidedetail-info">{{bagInfo.listen|initNumber}} 收听</p>
      <div class="guidedetail-text"><span>{{bagInfo.guideinfo || '暂无个人简介'}}</span></div>
      <p class="bottom-border"></p>
    </div>

    <!--新版顶部-->
    <!--<div class="top-bg"></div>-->
    <!--<div class="guide-box border-box clearfix">-->
      <!--<p class="fl guide-img-box">-->
        <!--<img class="img guide-img" v-lazy="bagInfo.img" @click="seeImg(0,bagInfo.img)" />-->
        <!--<img class="guide-video-icon" v-on:click="btnVideo()" v-if="hasVideo==1" src="../../assets/icon_play_btn10.png"/>-->
      <!--</p>-->
      <!--<div class="fl guide-info">-->
        <!--<p class="guide-name">-->
          <!--<span class="fl" style='font-weight:bold;'>{{bagInfo.name}}</span>-->
          <!--<span class="guidedetail-des fl" v-if="bagInfo.guidetag != null && bagInfo.guidetag != ''">{{bagInfo.guidetag}}</span>-->
        <!--</p>-->
        <!--<div class="guide-text hide3">{{bagInfo.guideinfo || '暂无个人简介'}}</div>-->
        <!--<div class="data-box box">-->
          <!--<div class="flex">-->
            <!--<span class="data-num">{{bagInfo.listen|initNumber}}</span>-->
            <!--<span class="data-tit">收听量</span>-->
          <!--</div>-->
          <!--<div class="flex">-->
            <!--<span class="data-num">{{bagInfo.listen|initNumber}}</span>-->
            <!--<span class="data-tit">视频作品</span>-->
          <!--</div>-->
          <!--<div class="flex">-->
            <!--<span class="data-num">{{bagInfo.listen|initNumber}}</span>-->
            <!--<span class="data-tit">语音作品</span>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->

    <!--语音视频切换栏-->
    <p class="video-list-title">
      <span :class="typeList==0?'curr':''" @click="typeList=0">语音专辑</span>
      <span :class="typeList==1?'curr':''" @click="typeList=1" v-if="total1>0">视频专辑</span>
    </p>

    <!--语音列表-->
    <div class="video-list-ul border-box" v-show="typeList==0">
      <div class="list-box box border-box" v-for="(item,index) in bagList" :key="index" v-if="item.bagtype!=4">
        <div class="block list-img">
          <span class="type-lable" v-if="item.label!=null&&item.label!=''">{{item.label}}</span>
          <span class="type-lable" v-else-if="item.bagtype==2">VR</span>
          <img class="img icon-tx" v-lazy="item.shoplogo"  @click="seeImg(0,item.shoplogo)" />
          <p class="listen-num">
            <img src="../../assets/icon_st_num.png" />
            {{item.listen|initNumber}}{{item.bagtype==2?'观看':'收听'}}
          </p>
        </div>
        <div class="block flex list-info" @click="goVideoPlay(index)">
          <p class="has-bought" v-if="item.buynum<=0 && item.dsnum > 0 &&item.noReward!=1">
            <span class="fl" style='color:#333;'>{{item.dsnum|initNumber}}人打赏</span>
          </p>
          <p class="has-bought" v-if="item.price !=0 && item.buynum > 0">
            <span class="fl" style='color:#333;'>{{item.buynum|initNumber}}人购买</span>
          </p>

          <p class="list-name hide"><span class="fl guide-name border-box hide">{{item.name}}</span></p>
          <p class="list-group hide">{{item.shopname}}</p>

          <div class="price-text-box clearfix">
            <p class="price-text">
              <span style="color: #faaf39;" v-if="item.price==0">免费</span>
              <span style="color: #faaf39;" v-else>{{item.price}}元</span>
              (包含{{item.sees}}个景点解说)
            </p>
          </div>
          <p class="btn listen-btn" v-if="(!(item.buy==12||item.price==0||item.isuser)) && item.bagtype!=2" @click.stop="listenTurlClick(index)">
            <span>{{item.isplay==1?item.resTime+"'":"试听"}}</span>
            <img src="../../assets/icon_listen01.gif" alt="" v-if="item.isplay==1">
            <img src="../../assets/icon_listen01.png" alt="" v-if="item.isplay==0">
          </p>
          <div class="btn buy-btn"   v-if="(item.buy>0)||(item.price==0)||(item.isuser)" style="margin-left:0;">{{item.bagtype==2?'观看':'收听'}}</div>
          <button v-else class="btn buy-btn"  @click.stop="buyVideo(index)">购买{{item.bagtype==2?'观看':'收听'}}</button>
        </div>
      </div>
      <p class="load-tip" ref="loadtip">{{loadText}}</p>
    </div>

    <!--视频列表-->
    <div class="list border-box"  v-show="typeList==1&&total1>0">
      <div class="list-item box border-box" v-for="(item,index) in videoList" :key="index">
        <div class="block list-img">
          <img class="img" v-lazy="item.tvideourl"  @click="seeImg(0,item.tvideourl)" />
        </div>
        <div class="block flex list-info" @click="goVideoList(index)">
          <p class="list-name hide">{{item.bagname}}</p>
          <p class="list-shop hide">{{item.shopname}}</p>
          <p class="list-num">
            <img src="../../assets/detail_icon3.png" />
            {{item.play|initNumber}}播放
          </p>
          <p class="list-num" style="margin-top: .14rem;">
            <img src="../../assets/detail_icon2.png" />
            包含{{item.spots}}景点视频
          </p>
          <button class="btn buy-btn" v-if="(item.isbuy>0)||(item.price==0)||(item.isuser==1)" @click.stop="goVideoList(index)">观看</button>
          <button v-else class="btn buy-btn"  @click.stop="buyVideoList(index)">购买</button>
        </div>
      </div>
      <p class="load-tip" ref="loadtip">{{loadText1}}</p>
    </div>

    <!--试听结束弹窗新版-->
    <AlertListenEnd  :bag="bag" :couponid="couponid" :extral="extral" @close="closeEnd" v-if="Object.keys(bag).length>0"></AlertListenEnd>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>


    <!--视频播放弹窗-->
    <div class="guide-video" :class="{'none':videoAlert==0}">
      <img class="video-close" v-on:click="pauseVideo()" src="../../assets/red-envelopes-close.png" alt="">
      <div class="guide-video-con" v-on:click="playVideo()">
        <video id="videoPlay" :src="bagInfo.video" :poster="bagInfo.videoimg" @play="play"  preload="auto"
               webkit-playsinline="true" playsinline="true" x5-playsinline="true" x-webkit-airplay="allow"></video>

        <img class="guide-play"  src="../../assets/guide-play.png" alt="" v-show="isVideoPlay==false">
      </div>
    </div>


  </div>

</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import {getGuideinfo,getGuideVideos} from "@/service/getData";
  import { wxImgPreview, wxShareme, listenEndOrder, listenTurl, creatOrder, pushOrder} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import AlertListenEnd from '../../components/AlertListenEnd'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        id: '', //导游id
        userInfo: {}, //用户信息
        bagList:[],//语音列表
        videoList:[],//视频列表
        total: '',//语音总数
        total1: '',//视频专辑总数
        page: 1,
        page1: 1,
        rows: 10,
        loadText: "数据加载中",
        loadText1: "数据加载中",
        bagInfo:'',//导游详情
        audioPlay: 0, //个人简介语音播放状态
        audioGuide: '', //导游音频
        Audio: '', //音频dom
        videoTimer: null, //语音播放计时器
        currIndex: -1, //当前播放音频数组下标
        index1: 0, //当前播放音频数组下标(用来记录currIndex，传值给下订单方法)
        bag:{}, //当前试听的专辑
        extral:{}, //存放下单需要的值
        couponid: '', //优惠券id
        appKey: '',
        appKeyA: '',
        TimeStamp: new Date().getTime(),  //获取当前时间
        videoAlert:0,//导游视频弹窗
        hasVideo:0,//导游是否有视频
        isVideoPlay: false,  //视频没有在播放
        typeList: this.$route.query.typeList || 0,//0：语音列表 1：视频列表
      }
    },
    computed: {

    },
    created() {
//      this.bjImg = bjImg;
      this.$loading.show('数据加载中');

      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey": this.appKey});
      } else {
        setStore("appKey", {"appKey": ""});
      }

      this.id = this.$route.query.id;
      this.userInfo = getStore("userInfo");

      this.autoPlay();
      this.initData(this.page);
      this.initGuideVideo(this.page1);

      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun);
      if(this.videoTimer){
        clearInterval(this.videoTimer);
        this.currIndex = -1;
        this.bagList[this.index1].isplay = 0;
        this.bag = {};
      }
    },
    methods: {

      async initData(page){
        let res = await getGuideinfo({
          TimeStamp: this.TimeStamp,
          page: page,
          rows: this.rows,
          bid: this.id,
          openid: this.userInfo.openid
        });
        console.log(res);
        if (res.errcode === '00000'){
          this.$loading.hide();
          this.bagInfo = res.data;
          this.total = res.data.total;
          if(this.bagInfo.video!=null&&this.bagInfo.video!=''){
            this.hasVideo = 1;
          }
          for(var i=0; i<res.data.root.length; i++){
            res.data.root[i].isplay = 0;
            res.data.root[i].toaTime = '';
            res.data.root[i].resTime = '';
          }
          let bagList = res.data.root;
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (bagList.length > 0) {
            this.bagList = [...this.bagList, ...bagList];

            if(page == 1){
              this.audioGuide = document.getElementById('audioGuide');
              this.audioGuide.src = this.bagInfo.guidemp3;
            }
          } else {
            if (page == 1) {
              this.bagList = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          let title = this.userInfo.name + '@你：';
          let desc = this.bagInfo.name+'：我在"金牌解说"为您讲解景区故事';
          if(this.bagInfo.guideinfo != "" && this.bagInfo.guideinfo != null){
            desc = this.bagInfo.name+"："+this.bagInfo.guideinfo;
          }
          let img = this.bagInfo.img;
          let link = 'guide-info?id='+ this.id +'&TimeStamp='+ this.TimeStamp +'&appKey=' + (this.appKey);
          wxShareme(title,desc,img,link);

          this.$route.meta.title = this.bagInfo.name;
        }
      },

      async initGuideVideo(page1){
        let res = await getGuideVideos({
          TimeStamp: this.TimeStamp,
          page: page1,
          rows: this.rows,
          id: this.id,
          openid: this.userInfo.openid
        });
        console.log(res);
        if (res.errcode === '00000'){
          this.$loading.hide();
          this.total1 = res.data.total;

          let videoList = res.data.root;
          if (page1 >= Math.ceil(this.total1 / this.rows)) {
            this.loadText1 = '已经到底了'
          } else {
            this.loadText1 = '加载更多'
          }
          if (videoList.length > 0) {
            this.videoList = [...this.videoList, ...videoList];
          } else {
            if (page1 == 1) {
              this.videoList = [];
              this.loadText1 = '暂无数据'
            } else {
              this.loadText1 = '已经到底了'
            }
          }
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          if(self.typeList == 0){//0：语音列表 1：视频列表
            loadMore(self,function(page){
              self.initData(page);
            });
          }else if(self.typeList == 1){
            loadMore(self,function(page1){
              self.initGuideVideo(page1);
            });
          }

        })
      },

      autoPlay(){
        let self = this;
        self.$nextTick(function() {
          self.audioGuide = document.getElementById('audioGuide');
//          self.audioGuide.play();
        })
      },

      //播放导游语音
      playGuideVoice(){
        let self = this;
        self.$nextTick(() => {
          if (self.audioGuide.paused) {
            if(self.videoTimer != null){
              self.Audio.pause();
              self.bagList[self.index1].isplay = 0;
              clearInterval(self.videoTimer);
            }
            self.audioGuide.play();
            self.audioPlay = 1;
          } else {
            self.audioGuide.pause();
            self.audioPlay = 0;
          }
        })

      },

      //点击试听，调用试听公用方法
      listenTurlClick(ind){
        MtaH5.clickStat("guide_info_listen");
        if(!this.audioGuide.paused){
          this.audioGuide.pause();
          this.audioPlay = 0;
        }
        listenTurl(this,ind,this.bagList)
      },

      //点击购买，调用下订单公用方法
      buyVideo(ind){
        MtaH5.clickStat("guide_info_buy");
        MtaH5.clickStat('jingqujingdiana',{'2buy':'true'});//景区景点点击导游头像》2进入个人主页购买》支付
        let self = this;
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+self.bagList[ind].id+'&cid='+self.couponid+'&shopid='+self.bagList[ind].shopid+'&bagtype='+ self.bagList[ind].bagtype +'&appKey=' + (self.appKey)}`
        });
      },

      //点击购买，调用下订单公用方法
      buyVideoList(ind){
        let self = this;
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+self.videoList[ind].id+'&cid='+self.couponid+'&shopid=&bagtype=1&appKey=' + (self.appKey)}`
        });
      },

      //关闭试听弹窗，购买成功修改音频状态
      closeEnd(msg){
        this.bag = msg.bag;
        if(msg.isbuy){
          this.bagList[this.index1].buy = 12;
        }
      },

      //跳转到专辑详情页
      goVideoPlay(ind){
        if(this.bagList[ind].bagtype == "2"){
          this.$router.push({
            path: `/video-vr?${'id='+this.bagList[ind].id+'&shopid='+this.bagList[ind].shopid + '&TimeStamp='+ this.TimeStamp +'&appKey=' + (this.appKey)}`
          });
        }else {
          this.$router.push({
            path: `/video-play?${'id='+this.bagList[ind].id+'&shopid='+this.bagList[ind].shopid + '&TimeStamp='+ this.TimeStamp +'&appKey=' + (this.appKey)}`
          });
        }

      },

      //跳转到专辑详情页
      goVideoList(ind){
        this.$router.push({
          path: `/video-list?${'id='+this.videoList[ind].id+'&shopid='+this.videoList[ind].shopid + '&TimeStamp='+ this.TimeStamp +'&appKey=' + (this.appKey)}`
        });
      },

      //图片预览
      seeImg(ind,imgs){
        let arr = [];
        arr.push(imgs);
        wxImgPreview(imgs,arr);
      },

      //新增视频播放
      playVideo(){
        var vdo = document.getElementById("videoPlay");
        if (vdo.paused) {
          vdo.play();
          this.isVideoPlay = true;
          if(this.videoTimer != null){
            this.Audio.pause();
            this.bagList[this.index1].isplay = 0;
            clearInterval(this.videoTimer);
          }
          if(!this.audioGuide.paused){
            this.audioGuide.pause();
            this.audioPlay = 0;
          }
        } else {
          vdo.pause();
          this.isVideoPlay = false;
        }
      },
      pauseVideo(){
        var vdo = document.getElementById("videoPlay");
        vdo.pause();
        this.isVideoPlay = false;
        this.videoAlert = 0;
      },
      btnVideo(){
        this.videoAlert = 1;
      },
      play(){
        var vdo = document.getElementById("videoPlay");

        if(this.videoTimer != null){
          this.Audio.pause();
          this.bagList[this.index1].isplay = 0;
          clearInterval(this.videoTimer);
        }
        if(!this.audioGuide.paused){
          this.audioGuide.pause();
          this.audioPlay = 0;
        }

      },


  },
    watch:  {
      bag(newVal,oldVal){
        if(Object.keys(newVal).length){
          listenEndOrder(this,this.index1,this.bagList);
        }
      },
    },
    components: {
      AlertListenEnd
    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      }
    }

  }

</script>

<style scoped>
  .page{min-height:100vh;background:#ededed;}
  /*新版顶部*/
  .top-bg{position:relative;width:100%;height:2.8rem;background:linear-gradient(to bottom, #fbbd49 , #fccd5b);}
  .guide-box{position:relative;z-index:1;margin:-2.1rem .24rem 0;padding: .32rem .24rem .3rem;background: #fff;border-radius: .1rem;box-shadow: 0 .1rem .3rem rgba(0,0,0,.1);}
  .guide-box .guide-img-box{position:relative;width: 1.76rem;height: 2.45rem;border-radius: .1rem;}
  .guide-box .guide-img{width: 100%;height: 100%;border-radius: .1rem;}
  .guide-box .guide-info{width: calc(100% - 2rem);margin-left: .24rem;}
  .guide-box .guide-video-icon{position:absolute;bottom:.08rem;right:.10rem;width:.81rem;height:.46rem;border-radius:0 0 .13rem 0;}
  .guide-box .guide-name{position:relative;height:.36rem;line-height:.36rem;margin-top:.06rem;z-index:2;font-size:.36rem;color:#000;}
  .guide-box .guide-name .guidedetail-des{position:relative;height: .36rem;line-height: .36rem;padding: 0 .08rem;margin-left:.08rem;background: #f8ab39;color:#fff;font-size: .22rem;border-radius: .04rem;}
  .guide-box .guide-text{margin-top: .14rem;font: .24rem/.36rem "Microsoft YaHei";color: #2f2f2f;}
  .guide-box .data-box{width: 100%;margin-top: .2rem;}
  .guide-box .data-box .flex{position: relative;}
  .guide-box .data-box .flex:after{content:'';position: absolute;right: 0;top:50%;width:1px;height: .32rem;margin-top:-.16rem;background: #e5e5e5;}
  .guide-box .data-box .flex:last-child:after{display: none;}
  .guide-box .data-box .flex span{display: block;text-align: center;}
  .guide-box .data-box .flex span.data-num{font: bold .3rem "Microsoft YaHei";color: #333;}
  .guide-box .data-box .flex span.data-tit{margin-top:.1rem;font: .22rem "Microsoft YaHei";color: #666;}
  .video-list-title{width:100%;height:.74rem;line-height:.74rem;margin-top:.22rem;color:#080808;font-size:.30rem;border-bottom:.01rem solid #eaeaea;background:#fff;border-bottom: 1px solid #e5e5e5;}
  .video-list-title span{float:left;position:relative;width: 50%;text-align: center;font: bold .28rem/.74rem "Microsoft YaHei";color: #333;}
  .video-list-title span.curr:after{content: '';position: absolute;bottom:0;left: 50%;width:50%;height: .03rem;margin-left: -25%;background: #faaf39;}

  /*视频列表样式*/
  .list{padding: 0 .24rem .6rem;}
  .list .list-item{width: 100%;height: 2.15rem;padding:.24rem;margin-top:.24rem;background: #fff;border-radius: .1rem;box-shadow: 0 .1rem .3rem rgba(0,0,0,.1);}
  .list .list-img{width: 1.63rem;height: 100%;border-radius: .06rem;overflow: hidden;}
  .list .list-img img{width: 100%;height: 100%;}
  .list .list-info{position:relative;padding-left:.18rem;}
  .list .list-name{font: bold .32rem "Microsoft YaHei";color: #333;}
  .list .list-shop{margin-top: .16rem;color: #666;font-size: .24rem;font-weight: bold;}
  .list .list-num{width:100%;height:.24rem;line-height:.24rem;margin-top: .16rem;color:#666;font-size: .22rem;font-weight:bold;}
  .list .list-num img{float:left;width: auto;height: .24rem;margin-right:.1rem;}
  .list .buy-btn{position: absolute;right: 0;bottom: .33rem;width:auto;height: .48rem;margin-right: 0;padding: 0 .34rem;}


  /*旧版顶部及语音列表*/
  .guidedetail-top{position:relative;width:100%;min-height:48vh;padding:.01rem .24rem .36rem; }
  .bottom-border{position:absolute;left:0;right:0;bottom:0;height:.03rem;background:rgba(255,255,255,.2);}
  .guidedetail-bg{display:block;position:absolute;left:0;top:0;width:100%;height:100%;}
  .guidedetail-img-box{position:relative;z-index:2;width:2.00rem;height:2.00rem;margin-top:.28rem;border-radius:50%;overflow:hidden;}
  .guidedetail-img{width:100%;height:100%;border-radius:50%;}
  .guidedetail-video{position:absolute;bottom:.12rem;right:.10rem;width:.81rem;height:.46rem;border-radius:0 0 .13rem 0;}
  .guidedetail-name{position:relative;height:.58rem;line-height:.58rem;z-index:2;font-size:.36rem;color:#fff;}
  .guidedetail-name .guidedetail-des{position:relative;margin-left:.15rem;margin-top:.15rem;background: #f8ab39;color:#fff;font-size: .22rem;line-height: .34rem;padding: 0 .10rem;border-radius: .06rem .06rem .06rem 0;}
  .guidedetail-name .guidedetail-des:before{content: '';position: absolute;bottom:0;left: -.03rem;width: 0;height: 0;border-bottom: .14rem solid #f8ab39;border-left: .08rem solid transparent;border-right: .08rem solid transparent;}
  .guidedetail-info{position:relative;z-index:2;width:100%;height:.68rem;line-height:.68rem;font-size:.26rem;color:#fff;border-bottom:.01rem solid #8e8e8e;}
  .guidedetail-text{position:relative;z-index:2;margin-top:.40rem;}
  .guidedetail-text,.guidedetail-text span{display: block;width:100%;line-height:.34rem;font-size:.24rem;color:#fff;text-align:left;}
  .focus-btn{position:absolute;right:1.12rem;top:.86rem;z-index:2;height:.68rem;line-height:.68rem;padding:0 .56rem;font-size:.30rem;color:#fff;letter-spacing:.10rem;border-radius:.10rem;background:#ffb03b;}
  .listen-btn-top{position:absolute;right:.34rem;top:.86rem;z-index:2;width:.68rem;height:.68rem;border-radius:.10rem;background:#ffb03b;}
  .listen-btn-top img{position:absolute;left:50%;top:50%;width:.39rem;height:.34rem;transform:translate(-50%,-50%);}
  .guidedetail-share{position:absolute;right:.24rem;top:2.73rem;z-index:2;width:.39rem;height:.46rem;}
  .video-list-ul{padding:0 .24rem;}
  .list-box{width:100%;padding:.16rem .13rem .16rem 0;margin-top:.24rem;border:1px solid #eee;-webkit-border-radius:.13rem;border-radius:.1rem;box-shadow:0 0 .10rem #eee;overflow: hidden;background:#fff;}
  .list-img{float:left;position:relative;width:1.90rem;border-right:1px solid #eee;}
  .list-img .icon-tx{display:block;width:1.40rem;height:1.40rem;margin:0 auto;background:#fff;border-radius:.10rem;}
  .list-img img.icon-video{position:absolute;top:.40rem;right:.50rem;width:.50rem;height:.50rem;}
  .list-img .type-lable{position:absolute;left:-50%;top:-.04rem;width:1.80rem;height:.40rem;line-height:.40rem;margin-left:.34rem;color: #fff;font-size: .21rem;background: #ffbd08;transform: rotate(-45deg);text-align: center;box-shadow:0 .05rem .10rem #cec6b7;}
  .list-info{position:relative;padding-left:.2rem;}
  .listen-num{height:.24rem;line-height:.24rem;margin-top: .24rem;color:#666;font-size: .20rem;text-align: center;}
  .listen-num img{width: .24rem;height: .24rem;margin-right:.15rem;vertical-align: bottom;}
  .has-bought{position:absolute;top:0;right:0;height: .40rem;line-height: .40rem;font-size: .24rem;color: #797979;}
  .list-name{height:.38rem;line-height: .38rem;}
  .guide-name{width:100%;padding-right:1.50rem;font-weight:bold;font-size: .30rem;color:#3d3d3d;}
  .list-group{margin-top:.08rem;font-size:.24rem;color:#555;box-sizing: border-box;}
  .price-text-box{height:.57rem;line-height: .57rem;margin-top: .06rem;}
  .price-text{font-size: .26rem;color:#444;}
  .price-text span{font-size: .32rem;}
  .btn{ position: relative; display:inline-block;width:1.88rem;height:.50rem;line-height:.50rem;margin-right:.15rem;margin-top:.06rem;font-size:.26rem;text-align:center;color:#fff;border-radius:.30rem;float:left;}
  .btn.listen-btn{background:linear-gradient(to right, #fc7c6b , #ff553e);}
  .btn.buy-btn{background:linear-gradient(to right, #fccd5b , #fdae33);bottom: 0;}
  .btn img{width:.23rem;height:.23rem;}
  /*导游视频*/
  .guide-video{position: fixed;top:0;left: 0;width: 100%;height: 100%;background:rgba(0,0,0,.56);z-index: 99;}
  .guide-video-con{position: absolute;top:45%;left: 50%;width: 80%;height: 70%;border-radius: .12rem;background: none;transform: translate(-50%,-50%);overflow: hidden;}
  .guide-play{position: absolute;top:50%;left: 50%;width: 1.08rem;height: 1.08rem;transform: translate(-50%,-50%);z-index: 9;}
  .guide-play.curr{display: block;}
  #videoPlay{width:100%;height: 100%;background: none;border-radius: .12rem;}
  .video-close{position: absolute;left: 50%;width: .6rem;height: .6rem;margin-left: -.3rem;bottom: 9%;}

</style>



// WEBPACK FOOTER //
// src/page/guide-info/guide-info.vue